import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {getUrlInfo, Urls} from "../helpers/routeUtils";

interface DocumentMetaOptions {
  urls: Urls;
  favicon?: string;
  titlePrefix?: string;
  titleSuffix?: string;
}

export const useDocumentMeta = ({urls, favicon, titlePrefix, titleSuffix}: DocumentMetaOptions) => {
  const {pathname} = useLocation();

  useEffect(() => {
    if (favicon) {
      const el = document.getElementById("dynamic-favicon") as HTMLLinkElement | null;
      if (el) el.href = favicon;
    }
  }, [favicon]);

  useEffect(() => {
    const urlInfo = getUrlInfo(urls, pathname);
    const page = urlInfo?.titleKey;

    if (titlePrefix && page) {
      document.title = `${titlePrefix} | ${page}`;
    } else if (titleSuffix && page) {
      document.title = `${page} | ${titleSuffix}`;
    } else {
      document.title = titlePrefix || titleSuffix || page || "";
    }
  }, [pathname, titlePrefix, titleSuffix]);
};
